import { ContentLayout7Theme } from '@components/content/components/content-layout-7/enum';
import { ContentLayout7Style } from '@components/content/components/content-layout-7/model';

export const contentLayout7Style: { [key: string]: ContentLayout7Style } = {
  [ContentLayout7Theme.BLUE]: {
    backgroundColor: 'BLUE',
    textColor: 'WHITE',
    labelColor: 'GREY_ALPHA',
  },
  [ContentLayout7Theme.OPAL]: {
    backgroundColor: 'OPAL',
    textColor: 'BLACK',
    labelColor: 'GREY_LIGHT',
  },
};
